import { required, shape } from '@totalsoft/pure-validations';

export const scheduleTypeCellParamTemplateValidator = shape({
  seasonalityTypeId: required,
  scheduleTypeId: required,
  templateName: required
});
